export default () => {
    if (window.location.hash !== '') {
        setTimeout(() => {
            const scrollHeight = document.getElementById(window.location.hash.replace('#', '')).offsetTop;
            const headerHeight = document.querySelector('header').offsetHeight;
            const manualOffset = 50;
 
            window.scrollTo(0, scrollHeight - headerHeight - manualOffset );
        }, 100)
    }
 }
 